<template>
  <div>
    <div>
      <v-layout wrap class="fullWindowHeight">
        <v-flex xs12 sm6>
          <v-layout wrap align-center justify-center class="fullWindowHeight">
            <v-flex xs8 style="padding-bottom: 10vh">
              <div v-if="!hasEmailBeenSent">
                <h2 class="mb-2"><span v-html="$t('a')" /></h2>
                <div class="mb-6">{{ $t('b') }}</div>
                <v-layout wrap>
                  <v-flex xs12>
                    <div v-if="isSendingAuthEmail" >
                      <v-progress-linear indeterminate color="primary" class="mt-12"></v-progress-linear>
                    </div>
                    <div v-else>
                      <v-form @submit.prevent="sendAuthEmail">
                        <v-text-field v-model="email" outlined type="email" :label="$t('c')"/>
                        <v-layout wrap>
                          <v-flex xs6>
                            <v-btn type="submit" class="secondary" :disabled="!isEmailOk(email) && Boolean(email)">{{ $t('d') }}</v-btn>
                          </v-flex>
                          <v-flex xs6 text-end pt-1>
                            <router-link :to="'/login'" style="text-decoration: none"><small>{{ $t('g') }}</small></router-link>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
              <div v-else>
                <h2 class="mb-2">{{ $t('e') }} {{ email }}</h2>
                <div class="mb-6">{{ $t('f') }}</div>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6 class="greyBackground">
          <v-layout wrap class="fullWindowHeight" align-center>
            <v-flex xs12 text-center style="padding-bottom: 5vh">
              <img :src="hasEmailBeenSent ? images.emailSent : images.main" :height="$vuetify.breakpoint.xs ? null : '380px'">
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import vuei18n from '@/i18n'

const functionsUrlBase = {
  'localhost': 'http://localhost:5001/esnwebservices-dev/us-central1',
  'esnwebservices-dev.firebaseapp.com': 'https://europe-west1-esnwebservices-dev.cloudfunctions.net',
  'esnwebservices-prod.firebaseapp.com': 'https://europe-west1-esnwebservices-prod.cloudfunctions.net',
  'esnwebservices.com': 'https://europe-west1-esnwebservices-prod.cloudfunctions.net'
}[window.location.hostname]

export default {
  data: () => ({
    email: '',
    isSendingAuthEmail: false,
    hasEmailBeenSent: false,
    images: {
      main: require('@/assets/app/images/personal_data__flatline.svg'),
      emailSent: require('@/assets/app/images/new_message_flatline.svg'),
    },
  }),
  mounted() {
    if (this.$route.query.email && this.isEmailOk(this.$route.query.email)) {
      // Automatically send email
      this.email = this.$route.query.email
      this.sendAuthEmail()
    }
  },
  computed: {
  },
  methods: {
    isEmailOk(email) {
      return email && /.+@.+\..+/.test(email)
    },
    async sendAuthEmail() {
      if (!this.email) return;
      this.isSendingAuthEmail = true

      const { isUserExisting, isConsultant } = (await this.$functions.httpsCallable('isUserExisting')({ email: this.email })).data
      if (isUserExisting && !isConsultant) return this.$router.push('/login');
    
      const urlBase = `${window.location.hostname === 'localhost' ? 'http' : 'https'}://${window.location.host}`
      let url = new URL(`${urlBase}/consultant/login`)
      if (this.$route.query.lang) url.searchParams.set('lang', this.$route.query.lang);
      if (this.$route.query.invitationCode) url.searchParams.set('invitationCode', this.$route.query.invitationCode);

      await axios.post(`${functionsUrlBase}/sendEmailForConsultantLogin`, {
        url: url.href,
        email: this.email,
        locale: vuei18n.locale === 'en' ? 'en' : 'fr'
      })
      window.localStorage.setItem('emailForSignIn', this.email);

      this.hasEmailBeenSent = true
    }
  }
}
</script>



<i18n>
{
  "fr": {
    "a": "Bienvenue sur votre outil de création de votre dossier de compétences",
    "b": "Simple et rapide.",
    "c": "Votre adresse email",
    "d": "Se connecter",
    "e": "Un email d'authentification a été envoyé à",
    "f": "Cliquez sur le lien pour vous connecter.",
    "g": "Vous êtes un manager/recruteur ?"
  },
  "en": {
    "a": "Welcome to your CV converter tool.<br>Let's make your CV fit with your company's design.",
    "b": "Quick and easy.",
    "c": "Your email address",
    "d": "Log in",
    "e": "An authentication email has been sent to",
    "f": "Click on its link to get authenticated.",
    "g": "You are a manager/recruiter ?"
  }
}
</i18n>
